import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import profilePicThumbImg from "../assets/images/profile_av.png";
import { AiOutlineLogout } from "react-icons/ai";

export default function MenuDropdown({ user, handleLogout }) {
  return (
    <div>
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button
            title="menu"
            className="w-[38px] h-[38px] rounded-full overflow-hidden border-[4px] border-white grayscale-[30%] hover:filter-none transition duration-200"
          >
            <img src={user?.image || profilePicThumbImg} alt="User profile" />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 mt-2 min-w-[14rem] origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-custom focus:outline-none">
            <div className="px-1 py-1">
              <div className="flex items-center gap-4 p-3">
                <div className="w-[38px] h-[38px]">
                  <img
                    className="w-full h-full grayscale-[50%] hover:filter-none transition duration-100 rounded-full overflow-hidden object-cover"
                    src={user?.image || profilePicThumbImg}
                    alt={user?.name || "Unknown user"}
                  />
                </div>
                <div className="text-sm flex flex-col">
                  <span className="text-base text-black capitalize">
                    {user?.name || "Unknown user"}
                  </span>
                  <span className="text-[#9399a1]">
                    {user?.email || "No email found"}
                  </span>
                </div>
              </div>
            </div>
            <div className="">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={handleLogout}
                    className={`${
                      active
                        ? "bg-secondary/80 text-white"
                        : "bg-secondary text-white"
                    } group flex w-full items-center rounded-b-md gap-1 uppercase tracking-wide px-2 py-3 text-sm justify-center`}
                  >
                    Sign out
                    <AiOutlineLogout className="text-base" />
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
